export enum LimitationType {
  LIMITED = "LIMITED",
  PROHIBITED = "PROHIBITED",
  UNLIMITED = "UNLIMITED"
}